/* eslint-disable */
import React from 'react';
import { H1 } from 'components/core/Headline';

export default () => (
	<div>
		<H1 size="large">SpareFoot, Inc. Client Terms of Service</H1>
		<p>This Terms of Service (the &ldquo;<strong>Agreement</strong>&rdquo;) explains the contractual agreement
			between SpareFoot, Inc., a Delaware corporation with offices at 3300 N-IH35,
			Suite 200, Austin, TX 78705 (&ldquo;<strong>SpareFoot</strong>&rdquo;) and you, a self-storage facility owner
			or operator (&ldquo;<strong>Client</strong>&rdquo;).
			This Agreement is made to be effective as of the date accepted by SpareFoot (the
			&ldquo;<strong>Effective Date</strong>&rdquo;) following
			your electronic acceptance of the Agreement via The SpareFoot website. This Agreement
			governs the terms and conditions pursuant to which SpareFoot will provide you with
			access to certain SpareFoot&rsquo;s proprietary services described in Section 1, below
			(each, a &ldquo;<strong>Service</strong>&rdquo; and
			collectively, the &ldquo;<strong>Services</strong>&rdquo;). In consideration of the mutual promises contained herein, the parties
			agree as follows:
		</p>
		<p>By your electronic acknowledgement of this Agreement,
			you accept the terms and conditions of this Agreement and are representing and
			warranting that you can legally enter into this Agreement and satisfy all of the
			requirements hereunder. If you have any questions about this Agreement, please call us
			at (512) 705-6208 or email us at support@sparefoot.com.
		</p>
		<p><strong>1. Background</strong></p>
		<p>SpareFoot is a provider of multiple Services, including
			but not limited to the SpareFoot AdNetwork Service (&ldquo;<strong>AdNetwork</strong>&rdquo;), the SpareFoot SiteBuilder Service
			(&ldquo;<strong>SiteBuilder</strong>&rdquo;), the
			SpareFoot Booking Widget (&ldquo;<strong>Booking
			Widget</strong>&rdquo;), and the SpareFoot GeoPages Service
			(&ldquo;<strong>GeoPages</strong>&rdquo;). Client
			desires to obtain and SpareFoot desires to provide Client with access to one or more of
			the Services pursuant to this Agreement. Service-specific terms and conditions (each,
			&ldquo;<strong>Supplemental Terms</strong>&rdquo;) apply
			to one or more of the Services based on Client&rsquo;s activation and use of the
			specific Service, with SpareFoot&rsquo;s permission. Supplemental Terms are specified
			in the exhibits attached hereto. Any applicable Supplemental Terms shall (together with
			this Agreement) constitute the entire agreement between Client and SpareFoot with
			respect to the specific Service. Terms capitalized in the Supplemental Terms but not
			defined therein shall have the meanings given to them in this Agreement. In the event
			of a conflict between this Agreement and any such Supplemental Terms, the Supplemental
			Terms shall apply, solely with respect to such Service.
		</p>
		<p><strong>2. Service</strong></p>
		<p>2.1 Provision of
			Services. Subject to the terms and conditions of this
			Agreement, including without limitation payment of the applicable fees, if any,
			specific to a Service, SpareFoot will provide Client with access to the Service(s) as
			specified in the applicable Supplemental Terms.&nbsp;Client may
			use the Service(s) solely for its/their intended purpose in accordance with this
			Agreement and any Supplemental Terms.
		</p>
		<p>2.2 Client
			Assistance. Client shall provide SpareFoot with all information
			and assistance as reasonably required for SpareFoot to activate and operate the
			Service(s) for Client pursuant to this Agreement. Client grants SpareFoot all rights or
			licenses necessary for SpareFoot to use such information in connection with the
			provision of the Service(s).
		</p>
		<p>2.3 Access to
			Service. Client acknowledges that maintenance may be required
			from time to time and as a result the Service(s) may be offline from time to
			time.
		</p>
		<p>2.4 Customer Reviews.  In connection with the Service, client's customers may submit reviews of Client facilities via SpareFoot's website, by survey or otherwise.  Client acknowledges SpareFoot's right to publish reviews concerning Client's facilities and that reviews submitted to SpareFoot and posted on its website reflect the opinions and beliefs of the individual reviewers and not of SpareFoot or any of its affiliates, officers, directors or employees. SpareFoot is not responsible and assumes no liability for any reviews, or for any loss or damage related to such reviews. Client may not review Client facilities or any competing facilities. SpareFoot will not necessarily delete valid, negative reviews of any facility or monitor the reviews or related responses, though it reserves the right to do so. Client may post one response to each customer review of its facilities, so long as the response does not violate SpareFoot's Review Terms and Conditions, available [<a href="/reviewstoc.html">here</a>].  SpareFoot encourages Client to respond to any negative reviews and identify how it intends to rectify the customers' concerns.  If Client believes a review of a Client facility is fraudulent or in violation of SpareFoot's Review Terms and Conditions, Client should contact SpareFoot at support@sparefoot.com. If after reviewing the information provided by Client regarding the potentially fraudulent review, SpareFoot may, but is not required to, remove the review from its website.</p>
		<p><strong>3. Client Obligations</strong></p>
		<p>3.1 Rights Regarding
			Site(s). Client certifies that it owns or has all necessary
			rights to control the website(s), if any, that is/are integrated with or linked with
			the Service(s) (the &ldquo;<strong>Client Site(s)</strong>&rdquo;), and that to the extent required and applicable, Client has all rights
			necessary to integrate the Service(s) with the Client Site, to administer the Service,
			and to fulfill its obligations under this Agreement.
		</p>
		<p>3.2 Bug
			Reporting. Client shall promptly report to SpareFoot all bugs
			and errors related to the Service(s) of which Client becomes aware.
		</p>
		<p><strong>4. Fees</strong></p>
		<p>4.1.1 Fees. SpareFoot shall be paid the fees, if any,
			set forth in the Supplemental Terms accepted by Client. All fees are non-refundable,
			provided that if any Service that is for a specified term is terminated by SpareFoot
			pursuant to Section 7.2.1, then SpareFoot shall refund a pro-rated portion of any
			pre-paid subscription fee.
		</p>
		<p>4.2 Invoicing. SpareFoot shall invoice Client for any
			applicable fees incurred by the Client from time to time in connection with the
			Service(s). Unless otherwise specified in the applicable Supplemental Terms, all fees
			are due and payable in U.S. dollars within thirty (30) days of receipt by Client of the
			SpareFoot invoice. All fees are exclusive of applicable sales, excise, or use taxes,
			which shall be the sole responsibility of Client.
		</p>
		<p>4.3 Late
			Payments. If payment is not made within thirty (30) days after
			the invoice date, SpareFoot may charge Client a late fee on the unpaid balance at the
			lesser of one-and-a-half percent (1.5%) per month or the maximum lawful rate permitted
			by applicable law, rounded to the next highest whole month and compounded monthly.
			SpareFoot may also charge Client for all expenses of collection. Should Client not pay
			amounts when due, SpareFoot may (at its discretion and in addition to other remedies it
			may have) deactivate the Service(s).
		</p>
		<p><strong>5. Proprietary Rights</strong></p>
		<p>5.1 Ownership of the
			Service. SpareFoot shall own all right, title, and interest in
			and to the Service, including all modifications, improvements, upgrades, and derivative
			works related thereto and all intellectual property rights therein. Client agrees to
			assign all right, title, and interest it may have in the foregoing to SpareFoot.
			If Client provides or creates feedback
			in connection with the Service(s) (&ldquo;<strong>Feedback</strong>&rdquo;), Client hereby assigns and agrees to
			assign all of its right, title, and interest in and to such Feedback to SpareFoot. To
			the extent that the foregoing assignment is ineffective for whatever reason, Client
			hereby grants and agrees to grant to SpareFoot a non-exclusive, perpetual, irrevocable,
			royalty free, worldwide right and license to use, reproduce, disclose, sub-license,
			distribute, modify and otherwise exploit such Feedback without restriction.
		</p>
		<p>5.2 Restrictions. Client shall not, and shall not authorize
			any third party to (i) modify, adapt, reverse engineer, disassemble, de-compile or
			otherwise derive source code from the Service; (ii) create derivative works based on
			the Service; (iii) transfer the Service or any part thereof to any third party without
			SpareFoot&rsquo;s prior written consent, or (iv) use the software that embodies the
			Service other than as intended and directed by SpareFoot in connection with the
			integration thereof with the Client Site. Client shall not remove, alter, cover or
			obfuscate any copyright notices or other proprietary rights notices or proprietary mark
			placed or embedded by SpareFoot on or in the Service.
		</p>
		<p>5.3 Data
			Ownership. SpareFoot shall own all right, title, and interest
			in and to any data that is collected by SpareFoot from Client or provided by Client or
			consumers in connection with Client&rsquo;s use of the Service
			(&ldquo;<strong>Data</strong>&rdquo;).
			SpareFoot, at its discretion, may distribute
			this data to other sites, forums, aggregators, or other 3rd parties for the purpose of
			promoting Client facilities either individually or in aggregate, pursuant to providing the agreed Service to Client. Data that is published to
			the Internet on behalf of Client to effect the Service is considered publicly available
			and not bound by any confidentiality provisions. This includes but is not limited to
			facility information, unit pricing, unit availability, photos, consumer reviews, and
			consumer survey responses.
		</p>
		<p>5.4 Confidentiality. Client shall (i) not disclose
			Confidential Information to any third party, (ii) may only use Confidential Information
			for the intended business purpose related to this Agreement and for the benefit of
			SpareFoot and (iii) protect Confidential Information from disclosure or misuse by using
			at least a reasonable degree of care. &ldquo;<strong>Confidential
			Information</strong>&rdquo; shall mean confidential or proprietary
			information that SpareFoot may provide to Client in connection with this Agreement. If
			Client is required by law to disclose Confidential Information in response to a valid
			order of a court of competent jurisdiction or authorized government agency, Client
			shall give SpareFoot prompt written notice of such requirement to allow SpareFoot to
			obtain a protective order prior to disclosure, and shall cooperate with SpareFoot in
			such process.
		</p>
		<p>5.5 Integration. Client may elect to manage their Service
			manually, or integrate with SpareFoot via an existing software vendor. Software vendors
			supported by SpareFoot include but are not limited to SiteLink, CenterShift, Domico,
			Self Storage Manager, and QuikStor (the &ldquo;<strong>Vendor</strong>&rdquo;). Specific to data available via the agreed
			Vendor, (the &ldquo;<strong>Database</strong>&rdquo;),
			Client grants to SpareFoot a non-exclusive, world-wide license to establish a link from
			SpareFoot&rsquo;s websites to Client&rsquo;s Database server (the
			&ldquo;<strong>Link</strong>&rdquo;) for the term of
			this Agreement. In its use of the Link and in its relationship with the Vendor,
			SpareFoot acts as an agent of Client. The Link enables Client and SpareFoot to maintain
			accuracy of unit pricing and availability information on SpareFoot websites and, if
			supported by the Vendor, allows SpareFoot to initiate reservations on behalf of
			prospective Client customers. Client shall be responsible for enabling the Link and
			obtaining all the necessary licenses, credentials, and authorizations from the Vendor
			to integrate the Database with SpareFoot&rsquo;s websites and allow SpareFoot to access
			the Database on Client&rsquo;s behalf. Client agrees that SpareFoot shall have the right, on behalf of Client, to view facility information,
			unit pricing and availability information, in addition to viewing tenant roster
			information pursuant to verifying move-ins.&nbsp;SpareFoot has
			the right to copy unit pricing and inventory information to SpareFoot systems as needed
			to efficiently provide the Service, but will not store tenant roster information other
			than to record and reconcile the fact that a specific reservation was consummated.
			Database information shall remain the sole and exclusive property of Client and/or the
			Vendor, as applicable.
		</p>
		<p><strong>6. Warranty and Limitations of Liability</strong></p>
		<p>6.1 Warranty
			Disclaimer. SERVICE(S) ARE PROVIDED TO CLIENT ON AN &ldquo;<strong>AS
			IS</strong>&rdquo; AND &ldquo;<strong>AS AVAILABLE</strong>&rdquo; BASIS, AND SPAREFOOT DISCLAIMS ALL WARRANTIES,
			CONDITIONS, OR REPRESENTATIONS (EXPRESS OR IMPLIED, ORAL, OR WRITTEN) WITH RESPECT
			THERETO AND WITH RESPECT TO ANY SUPPORT RELATED THERETO, INCLUDING ANY AND ALL
			WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT,
			NON-INTERFERENCE, ACCURACY OF DATA, AND WARRANTIES ARISING FROM A COURSE OF
			DEALING.
		</p>
		<p>6.2 Disclaimer of
			Consequential Damages. IN NO EVENT WILL SPAREFOOT BE LIABLE TO
			USER FOR ANY SPECIAL, CONSEQUENTIAL, INCIDENTAL OR OTHER DAMAGES, HOWEVER CAUSED AND ON
			ANY THEORY OF LIABILITY, AND WHETHER OR NOT SPAREFOOT HAS BEEN ADVISED OF THE
			POSSIBILITY OF SUCH DAMAGE.
		</p>
		<p>6.3 Maximum
			Liability. IN NO EVENT SHALL SPAREFOOT&rsquo;S AGGREGATE
			LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT, THE TERMINATION HEREOF, AND/OR
			PROVISION OF THE SERVICE EXCEED THE AMOUNTS PAID BY CLIENT TO SPAREFOOT FOR THE
			SPECIFIC SERVICE GIVING RISE TO THE CLAIM DURING THE TWELVE (12) MONTHS PRECEDING THE
			CLAIM. THIS LIMITATION OF LIABILITY IS CUMULATIVE AND NOT PER INCIDENT.
		</p>
		<p>6.4 Reasonable Allocation of
			Risk. The parties understand and agree that the limitations of
			liability set forth in this Section are a reasonable allocation of risk between the
			parties, and, absent such allocation, SpareFoot would not be able to charge the prices
			it is charges for the Service. The limitations of liability set forth in this Agreement
			shall apply notwithstanding any failure of essential purpose of any limited remedy
			provided herein.
		</p>
		<p><strong>7. Term of Agreement</strong></p>
		<p>7.1 Term. This Agreement will commence on the Effective Date and will continue for until
			terminated in accordance herewith. Any Term specified on any Supplemental Terms shall,
			unless a party notifies the other in writing not less than sixty (60) days prior to the
			end of the then current applicable Term, automatically renew for successive
			Terms.
		</p>
		<p>7.2 Termination.</p>
		<p>7.2.1 Convenience. SpareFoot may terminate this Agreement
			and/or any Supplemental Terms by providing written notice at any time.
		</p>
		<p>7.2.2 For
			Breach. In addition, SpareFoot may terminate this Agreement
			and/or any Supplemental Terms if Client is in breach of any term or condition set forth
			herein or therein, and such breach is not cured in the ten (10) day period following
			SpareFoot giving notice of such breach.
		</p>
		<p>7.3 Survival of Certain
			Terms. Notwithstanding any termination of this Agreement, the
			following provisions shall survive: Sections 4-6, 7.3, and 8, and any Supplemental
			Terms identified as provisions that shall survive the termination hereof. All other
			rights, obligations, and licenses set forth herein shall cease upon termination of this
			Agreement for any reason.
		</p>
		<p><strong>8. General Provisions</strong></p>
		<p>8.1 Compliance with
			Laws. Client shall comply with all applicable laws, rules,
			treaties, and regulations in its performance of this Agreement. Client will hold
			harmless, indemnify and defend SpareFoot from any claim against SpareFoot arising from
			Client&rsquo;s failure to comply with this paragraph.
		</p>
		<p>8.2 Governing Law and
			Jurisdiction. This Agreement shall be governed by and construed
			under the law of the State of Texas, without regard to principles of conflict of laws.
			The federal and state courts of Travis County, Texas shall have exclusive jurisdiction
			and venue to adjudicate any dispute arising out of this Agreement. Each party hereto
			expressly consents to the personal jurisdiction and venue of such courts.
		</p>
		<p>8.3 Notices. Any notice required or permitted by this
			Agreement will be in writing and will be sent by registered or certified mail, return
			receipt requested, or by reputable overnight courier addressed to the other party, or
			in the case of Client via email, at (i) the address shown at the beginning of this
			Agreement (in the case of SpareFoot), (ii) the address or email address provided to
			SpareFoot in connection with Client&rsquo;s registration for the Service(s), (in the
			case of Client), or (iii) such other address for which such party gives notice
			hereunder. Such notice will be deemed to have been given when delivered or, if delivery
			is not accomplished by some fault of the addressee, when tendered.
		</p>
		<p>8.4 Entire
			Agreement. This Agreement and any applicable Supplemental Terms
			set forth the entire agreement and understanding of the parties relating to the subject
			matter hereof and thereof. Any modification of or amendment to this Agreement, or any
			waiver of any rights under this Agreement, will be effective only if set forth in
			writing and signed physically or electronically by authorized employees of both
			parties, or if accepted subsequently by Client via a click to accept mechanism
			presented by SpareFoot.
		</p>
		<p>8.5 Severability. If any provision of this Agreement is
			held to be invalid by a court of competent jurisdiction, then the remaining provisions
			will nevertheless remain in full force and effect.
		</p>
		<p>8.6 No
			Waiver. The failure of either party to enforce at any time any
			of the provisions of the Agreement, or the failure to require at any time performance
			by the other party of any of the provisions of this Agreement, will in no way be
			construed to be a present or future waiver of such provisions.
		</p>
		<p>8.7 Force
			Majeure. Nonperformance of either party (except for payment
			obligations) will be excused to the extent that performance is rendered impossible by
			strike, fire, flood, lightening, governmental acts or orders or restrictions, failure
			of suppliers, or any other reason where failure to perform is beyond the reasonable
			control and not caused by the negligence of the non-performing party.
		</p>
		<p>8.8 Assignment and Binding
			Effect. SpareFoot may transfer or assign this Agreement and its
			rights and/or obligations hereunder. Client may transfer or assign its rights or
			obligations under this Agreement on providing written notice to SpareFoot, subject to
			SpareFoot&rsquo;s right to terminate as described in section 7.2.
		</p>
		<p>8.9 Injunctive
			Relief. Client agrees that any breach of its obligations
			regarding Confidential Information would result in irreparable injury for which there
			is no adequate remedy at law. Therefore, in the event of any breach or threatened
			breach of Client&rsquo;s obligations regarding Confidential Information, SpareFoot will
			be entitled to obtain equitable relief in addition to its other available legal
			remedies in a court of competent jurisdiction, without the necessity of proving actual
			damages or posting bond.
		</p>
		<p><strong>Exhibit A: SpareFoot AdNetwork Supplemental Terms</strong>
		</p>
		<p><strong>A1. Effectiveness of Terms</strong></p>
		<p>These Supplemental Terms (&ldquo;<strong>Supplemental Terms</strong>&rdquo;), together with SpareFoot Terms
			of Service, explain the contractual agreement between SpareFoot and Client with respect
			to Client&rsquo;s procurement of the SpareFoot AdNetwork Service. These Supplemental
			Terms are effective as of the date of AdNetwork Service activation by SpareFoot, based
			on Client request. SpareFoot reserves the right to deny activation of the Service at
			its sole discretion.
		</p>
		<p><strong>A2. Service</strong></p>
		<ol start="1">
			<li>SpareFoot will make vacant units at Client&rsquo;s
				facilities visible on the SpareFoot AdNetwork.
			</li>
			<li>SpareFoot will allow consumers to reserve units in
				Client&rsquo;s facilities via the SpareFoot AdNetwork, online and by
				phone.
			</li>
			<li>SpareFoot will allow Client to maintain
				information about its facilities via my.sparefoot.com.
			</li>
			<li>SpareFoot will obtain vacant inventory information
				from Client&rsquo;s storage management software provider, or if no software
				integration is available Client will provide and maintain their inventory information
				via the my.sparefoot.com website.
			</li>
		</ol>
		<p><strong>A3. Pricing and Payment Terms</strong></p>
		<a name="8fb98f252a52d553367c8c626726438e25ded3c0" /><a name="0" />
		<table cellPadding="0" cellSpacing="0">
			<tbody>
				<tr>
					<td>
						<p>Setup Fee</p>
					</td>
					<td>
						<p>No fee</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Transaction Fee (CPA)</p>
					</td>
					<td>
						<p>Client may bid any amount greater or equal to
							$75 per move-in processed. With the exception of
							Parking Spaces, bid is discounted 33% for units less
							than 50 sqft and increased by 66% for units 100 sqft or greater. Total amount
							due invoiced monthly by SpareFoot in arrears.
						</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Subscription Fee</p>
					</td>
					<td>
						<p>$50 per month, invoiced monthly by SpareFoot, in
							arrears
						</p>
					</td>
				</tr>
			</tbody>
		</table>
		<p><strong>A4. Service Deactivation</strong></p>
		<p>SpareFoot reserves the right to deactivate the AdNetwork
			Service without notice based on Late Payment, as described in section 4.3, or if it
			believes that Client is in violation of the Agreement or the AdNetwork Supplemental
			Terms. Client can voluntarily deactivate the AdNetwork Service without terminating the
			Agreement by written request to support@sparefoot.com, allowing 30 days for the removal
			of information from the SpareFoot AdNetwork. On request for deactivation, the AdNetwork
			Supplemental Terms will cease to be in effect, although Client will still be liable for
			any amounts due to SpareFoot incurred during the effective period.
		</p>
		<p><strong>A5. Client Obligations</strong></p>
		<p>Client agrees not to subvert the AdNetwork reservation
			system by publishing direct contact information on the AdNetwork, or use the AdNetwork
			in any way that encourages consumers to reserve Client storage units outside of the
			AdNetwork system. This includes but is not limited to publishing facility phone
			numbers, email addresses, or website addresses in Client facility descriptions,
			promotions, or photos.
		</p>
		<p><strong>Exhibit B: SpareFoot SiteBuilder Supplemental Terms</strong>
		</p>
		<p><strong>B1. Effectiveness of Terms</strong></p>
		<p>These Supplemental Terms (&ldquo;<strong>Supplemental Terms</strong>&rdquo;), together with SpareFoot Terms
			of Service, explain the contractual agreement between SpareFoot and Client with respect
			to Client&rsquo;s procurement of the SpareFoot SiteBuilder Service. These Supplemental
			Terms are effective as of the date of SiteBuilder Service activation by SpareFoot,
			based on Client request. SpareFoot reserves the right to deny activation of the Service
			at its sole discretion.
		</p>
		<p><strong>B2. Service</strong></p>
		<ol start="1">
			<li>SpareFoot will build and host a dedicated website
				for Client&rsquo;s storage facilities.
			</li>
			<li>SpareFoot will allow consumers to reserve units in
				Client&rsquo;s facilities via the dedicated website.
			</li>
			<li>SpareFoot will allow Client to maintain website
				content via the my.sparefoot.com website.
			</li>
			<li>SpareFoot will obtain vacant inventory information
				from Client&rsquo;s storage management software provider, or if no software
				integration is available Client can provide and maintain their inventory information
				via the my.sparefoot.com website.
			</li>
		</ol>
		<p><strong>B3. Pricing and Payment Terms</strong></p>
		<a name="7bcd5f9729b57a42424216b8e74d5904865814d7" /><a name="1" />
		<table cellPadding="0" cellSpacing="0">
			<tbody>
				<tr>
					<td>
						<p>Implementation Fee</p>
					</td>
					<td>
						<p>No fee</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Transaction Fee</p>
					</td>
					<td>
						<p>No fee for reservations or move-ins
							processed
						</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Subscription Fee</p>
					</td>
					<td>
						<p>$75 per month per storage facility, invoiced
							monthly by SpareFoot, in advance
						</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Fee Waivers</p>
					</td>
					<td>
						<p>First 30 days after service activation is free
							(Client not billed for this period)
						</p>
					</td>
				</tr>
			</tbody>
		</table>
		<p><strong>B4. Service Deactivation</strong></p>
		<p>SpareFoot reserves the right to deactivate the
			SiteBuilder Service without notice based on Late Payment, as described in section 4.3,
			or if it believes that Client is in violation of the Agreement or the SiteBuilder
			Supplemental Terms. Client can voluntarily deactivate the SiteBuilder Service without
			terminating the Agreement by written request to support@sparefoot.com, allowing 30 days
			for the hosted site to be removed. On request for deactivation, SiteBuilder
			Supplemental Terms will cease to be in effect, although Client will still be liable for
			any amounts due to SpareFoot incurred during the effective period.
		</p>
		<p>Exhibit C: SpareFoot GeoPages Supplemental
			Terms
		</p>
		<p><strong>C1. Effectiveness of Terms</strong></p>
		<p>These Supplemental Terms (&ldquo;<strong>Supplemental Terms</strong>&rdquo;), together with SpareFoot Terms
			of Service, explain the contractual agreement between SpareFoot and Client with respect
			to Client&rsquo;s procurement of the SpareFoot GeoPages Service. These Supplemental
			Terms are effective as of the date of GeoPages Service activation by SpareFoot, based
			on Client request. For clarity, the Service is considered active once the first listing
			is published in applicable search engines and/or directory sites. SpareFoot reserves
			the right to deny activation of the Service at its sole discretion.
		</p>
		<p><strong>C2. Service</strong></p>
		<ol start="1">
			<li>SpareFoot will insert local listings into
				applicable search engines and directory sites for each facility desired by
				Client.
			</li>
			<li>SpareFoot will build and host a dedicated webpage
				for each listed Client facility and direct web traffic from the local listing to the
				dedicated webpage.
			</li>
			<li>SpareFoot will allow consumers to reserve units in
				Client&rsquo;s facilities via the dedicated webpage(s).
			</li>
			<li>SpareFoot will allow Client to access GeoPages
				reservation and call information via my.sparefoot.com.
			</li>
			<li>SpareFoot will obtain vacant inventory information
				from Client&rsquo;s storage management software provider, or if no software
				integration is available Client can provide and maintain their inventory information
				via the my.sparefoot.com website.
			</li>
		</ol>
		<p><strong>C3. Pricing and Payment Terms</strong></p>
		<a name="be6752e3bb5ee26a4bcee712a0786a95233be34e" id="be6752e3bb5ee26a4bcee712a0786a95233be34e" /><a name="2" />
		<table cellPadding="0" cellSpacing="0">
			<tbody>
				<tr>
					<td>
						<p>Implementation Fee</p>
					</td>
					<td>
						<p>No fee</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Transaction Fee</p>
					</td>
					<td>
						<p>No fee for reservations or move-ins</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Subscription Fee</p>
					</td>
					<td>
						<p>$50 per month, per facility, invoiced monthly by
							SpareFoot, in advance
						</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Fee Waivers</p>
					</td>
					<td>
						<p>Subscription fee is refundable if service
							cancelled in first 30 days
						</p>
					</td>
				</tr>
			</tbody>
		</table>
		<p><strong>C4. Service Deactivation</strong></p>
		<p>SpareFoot reserves the right to deactivate the GeoPages
			Service without notice based on Late Payment, as described in section 4.3, or if it
			believes that Client is in violation of the Agreement or the GeoPages Supplemental
			Terms. Client can voluntarily deactivate the GeoPages Service without terminating the
			Agreement by written request to support@sparefoot.com, allowing 30 days for the changes
			to take effect. On deactivation, GeoPages Supplemental Terms will cease to be in
			effect, although Client will still be liable for any amounts due to SpareFoot incurred
			during the effective period.
		</p>
		<p><strong>Exhibit D: SpareFoot Booking Widget Supplemental Terms</strong>
		</p>
		<p><strong>D1. Effectiveness of Terms</strong>
		</p>
		<p>These Supplemental Terms (&ldquo;<strong>Supplemental Terms</strong>&rdquo;), together with SpareFoot Terms
			of Service, explain the contractual agreement between SpareFoot and Client with respect
			to Client&rsquo;s procurement of the SpareFoot Booking Widget Service. These
			Supplemental Terms are effective as of the date of Booking Widget Service activation by
			SpareFoot, based on Client request. For clarity, the Service is considered active once
			the Booking Widget is published on one or more Client websites. SpareFoot reserves the
			right to deny activation of the Service at its sole discretion.
		</p>
		<p><strong>D2. Service</strong></p>
		<ol start="1">
			<li>SpareFoot will make available software for Client
				to publish one or more Booking Widgets on Client owned website(s).
			</li>
			<li>The SpareFoot Booking Widget allows consumers to
				reserve units in Client&rsquo;s facilities, directly from Client&rsquo;s website(s),
				as enabled by Client.
			</li>
			<li>SpareFoot will allow Client to access Booking
				Widget reservation information via my.sparefoot.com.
			</li>
			<li>SpareFoot will obtain vacant inventory information
				from Client&rsquo;s storage management software provider, or if no software
				integration is available Client can provide and maintain their inventory information
				via the my.sparefoot.com website.
			</li>
		</ol>
		<p><strong>D3. Pricing and Payment Terms</strong></p>
		<a name="a5dec2ce5d25914932401c3836775d6f861c0693" id="a5dec2ce5d25914932401c3836775d6f861c0693" /><a name="3" />
		<table cellPadding="0" cellSpacing="0">
			<tbody>
				<tr>
					<td>
						<p>Implementation Fee</p>
					</td>
					<td>
						<p>No fee</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Transaction Fee</p>
					</td>
					<td>
						<p>No fee for reservations or move-ins</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Subscription Fee</p>
					</td>
					<td>
						<p>No fee</p>
					</td>
				</tr>
			</tbody>
		</table>
		<p><strong>D4. Service Deactivation</strong></p>
		<p>SpareFoot reserves the right to deactivate the Booking
			Widget Service without notice based on Late Payment, as described in section 4.3, or if
			it believes that Client is in violation of the Agreement or the Booking Widget
			Supplemental Terms. Client can voluntarily deactivate the Booking Widget Service by
			removing the Booking Widget software from their website(s). On deactivation, GeoPages
			Supplemental Terms will cease to be in effect.
		</p>
		<p><strong>D5. Software Warranty</strong></p>
		<p>The Booking Widget software is provided as-is, with all
			provisions of section 6.&nbsp;in
			force.
		</p>
		<p><strong>Exhibit F:&nbsp;SpareFoot Insights Supplemental Terms</strong>
		</p>
		<p><strong>F1.&nbsp;Effectiveness of Terms</strong></p>
		<p>These Supplemental Terms (&ldquo;<strong>Supplemental Terms</strong>&rdquo;), together with SpareFoot Terms
			of Service, explain the contractual agreement between SpareFoot and Client with respect
			to Client&rsquo;s procurement of the SpareFoot Insights Service. These Supplemental
			Terms are effective as of the date of Insights Service activation by SpareFoot, based
			on Client request. SpareFoot reserves the right to deny activation of the Service at
			its sole discretion, refunding any advance payment for the Service, if
			applicable.
		</p>
		<p><strong>F2. Service</strong></p>
		<ol start="1">
			<li>SpareFoot will make available to client via
				my.sparefoot.com reports on average regional self storage pricing specific to each of
				clients facilities where service is activated.
			</li>
			<li>SpareFoot will allow client to access, view, and
				download reports for the duration of service activation.
			</li>
			<li>SpareFoot reports will consist of historical
				monthly data accumulated for the duration of service activation.
			</li>
		</ol>
		<p><strong>F3. Pricing and Payment Terms</strong></p>
		<a name="2bfd4a31bcd844c6e7020416a1a36b3990407135" /><a name="4" />
		<table cellPadding="0" cellSpacing="0">
			<tbody>
				<tr>
					<td>
						<p>Setup Fee</p>
					</td>
					<td>
						<p>No fee</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Subscription Fee</p>
					</td>
					<td>
						<p>$50 per month, per facility, in
							advance
						</p>
					</td>
				</tr>
				<tr>
					<td>
						<p>Fee Waivers</p>
					</td>
					<td>
						<p>Free with $50 per facility subscription to
							AdNetwork
						</p>
					</td>
				</tr>
			</tbody>
		</table>
		<p><strong>F4. Service Deactivation</strong></p>
		<p>SpareFoot reserves the right to deactivate the Insights
			Service without notice based on Late Payment, as described in section 4.3, or if it
			believes that Client is in violation of the Agreement or the Insights Supplemental
			Terms. Client can voluntarily deactivate the Insights Service without terminating the
			Agreement by written request to support@sparefoot.com. Deactivation will occur at the
			end of the calendar month when notice is received. On deactivation of the Service, the
			Insights Supplemental Terms will cease to be in effect, although Client will still be
			liable for any amounts due to SpareFoot incurred during the effective
			period.
		</p>
		<p><strong>F5. Data Warranty</strong></p>
		<p>Data reports are provided as-is, and SpareFoot does not
			warrant accuracy or suitability for any specific purpose.
		</p>
		<p><strong>Exhibit G: SpareFoot Local Supplemental Terms</strong></p>
		<p><strong>G1. Effectiveness of Terms</strong></p>
		<p>These Supplemental Terms (&ldquo;<strong>Supplemental Terms</strong>&rdquo;), together with SpareFoot Terms
			of Service, explain the contractual agreement between SpareFoot and Client with respect
			to Client&rsquo;s procurement of the SpareFoot Local Service. These Supplemental Terms
			are effective as of the date of SpareFoot Local Service activation by SpareFoot. The
			SpareFoot Local Service may be activated at SpareFoot&rsquo;s discretion, provided that
			a) Client is active on the SpareFoot AdNetwork service, and b) prior to activation
			Client has been notified of their right to opt out of activation of the SpareFoot Local
			Service and has chosen not to opt out.
		</p>
		<p><strong>G2. Service</strong></p>
		<ol start="1">
			<li>SpareFoot will publish and manage Client facility
				listings on supported local listing directories (&ldquo;<strong>Directories</strong>&rdquo;), which
				refer consumers to specific Client facilities on the SpareFoot AdNetwork.
			</li>
			<li>SpareFoot will provide reservation services to
				consumers, as per the AdNetwork service, A2.
			</li>
			<li>Supported Directories include but are not limited
				to CityGrid, AT&amp;T (phone-based), Marchex, MerchantCircle, SuperPages, and
				Local.com.
			</li>
			<li>SpareFoot will pay all fees associated with
				publication of Client facilities on Directories, and manage Directory relationships
				on behalf of Client.
			</li>
			<li>SpareFoot will publish Client facilities on
				additional Directories, as they become available.
			</li>
		</ol>
		<p><strong>G3. Pricing and Payment Terms</strong></p>
		<a name="e0dbd7498ffebbbcbb23d64feffaaf745a83f11c" id="e0dbd7498ffebbbcbb23d64feffaaf745a83f11c" /><a name="5" />
		<table cellPadding="0" cellSpacing="0">
			<tbody>
				<tr>
					<td>
						<p>Transaction Fee (CPA)</p>
					</td>
					<td>
						<p>Reservations sourced via SpareFoot Local are
							priced as per the AdNetwork terms, A3.
						</p>
					</td>
				</tr>
			</tbody>
		</table>
		<p><strong>G4. Service Deactivation</strong></p>
		<p>SpareFoot reserves the right to deactivate the SpareFoot
			Local Service in conjunction with deactivation of the AdNetwork Service, as described
			in section A4. In addition, Client can voluntarily deactivate the SpareFoot Local
			Service without terminating the Agreement by written request to support@sparefoot.com,
			allowing up to 14 days for the removal of information from all Directories. On request
			for deactivation, the SpareFoot Local Supplemental Terms will cease to be in effect,
			although Client will still be liable for any amounts due to SpareFoot incurred during
			the effective period.
		</p>
		<p>SpareFoot may, from time to time, remove Client listings
			from one or more Directories, based on factors including but not limited to
			availability of advertising inventory, cost of inventory, and availability of Directory
			publishing systems to SpareFoot. Client may request removal from specific Directories,
			without terminating the SpareFoot Local Service, by written request to
			support@sparefoot.com.
		</p>
		<p><strong>G5. Data Warranty</strong></p>
		<p>SpareFoot does not warrant the accuracy of information
			on Directories, and client acknowledges that listing information can, from time to
			time, be replicated, incomplete, or missing, due to the interconnected and sometimes
			unreliable nature of Directory networks. Upon notification by Client of a listing
			error, SpareFoot will, with the applicable Directory, take commercially reasonable
			efforts to remedy the error within 14 days.
		</p>
	</div>
);
